/**
 * The icon set: 24×24 viewBox, 1.75px round strokes, no fills.
 *
 * Drawn for this project rather than pulled from a library: twelve paths
 * cost less than any icon package, and one stroke weight across all of them
 * keeps the set visually coherent.
 *
 * Each entry is a list of path `d` strings rendered by <Icon>.
 */
export const ICON_PATHS = {
  arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  arrowUpRight: ['M7 17L17 7', 'M8 7h9v9'],
  menu: ['M4 8h16', 'M4 16h16'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  sun: [
    'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    'M12 2v2',
    'M12 20v2',
    'M4.9 4.9l1.4 1.4',
    'M17.7 17.7l1.4 1.4',
    'M2 12h2',
    'M20 12h2',
    'M4.9 19.1l1.4-1.4',
    'M17.7 6.3l1.4-1.4',
  ],
  moon: ['M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z'],
  code: ['M8 7l-5 5 5 5', 'M16 7l5 5-5 5', 'M14 4l-4 16'],
  phone: ['M8 2.5h8a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2z', 'M11 18h2'],
  spark: [
    'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z',
    'M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z',
  ],
  cloud: ['M7 18a5 5 0 0 1-.6-9.96A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9z'],
  window: [
    'M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
    'M3 9h18',
    'M6.5 6.5h.01',
    'M9 6.5h.01',
  ],
  link: [
    'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1',
    'M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  ],
  mail: ['M4 6h16v12H4z', 'M4 7l8 6 8-6'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
} as const satisfies Record<string, readonly string[]>;

export type IconName = keyof typeof ICON_PATHS;
